export interface OneSearchInputState {
  searchText: string;
}

export const initialInputState: OneSearchInputState = { searchText: '' };
